import {black_circle} from "./constant";

export const toTitleCase = (phrase) => {
    if (phrase) {
        return phrase
            .toLowerCase()
            .split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    }
};

export const createTitle = (apartment, guestsStr) => {
    return apartment?.apartmentCategory.apartmentSize.sizeNaming + " " + apartment?.apartmentCategory.apartmentNaming?.title + " " + black_circle + " " + guestsStr;
};

// For german language
export const toLowerCaseIfNotGerman = (locale, value) => {
    if (locale !== "de-at" && locale !== "de-de" && locale !== "de-ch") {
        return value.toLowerCase();
    }
    return value;
};